import * as React from "react"
import { useTheme } from "@mui/material"
import { DateRangePickerSeeker } from "@ui-seeker/core"

import { DATE_PERIODS } from "@constants"
import { currentPeriod, dateRange } from "@signals"
import DIPDateRangeIcon from "./Icon"
import { dipRangeDates } from "./Ranges"


export default function DIPDateRange({ ...props }) {
	const { palette } = useTheme()

	return <DateRangePickerSeeker
		placement="leftStart"
		value={dateRange.value}
		onChange={e => dateRange.value = e}
		caretAs={() => <DIPDateRangeIcon />}
		ranges={dipRangeDates}
		onOk={() => currentPeriod.value = DATE_PERIODS.CUSTOM}
		containerProps={{ fullWidth: false }}
		css={{
			"div[role='combobox']": {
				borderColor: palette.background.default,
				backgroundColor: `${palette.background.default} !important`,
				paddingRight: "0 !important",
				height: 37,

				".rs-picker-toggle-textbox": {
					backgroundColor: palette.background.default
				},

				"&.rs-picker-toggle-active": {
					borderColor: palette.background.default,
					boxShadow: `0 0 0 0 ${palette.background.default}`
				},

				"&:hover": {
					borderColor: `${palette.background.default} !important`
				},

				".rs-picker-toggle-value": {
					color: palette.text.disabled
				}
			}
		}}
		{...props}
	/>
}